export const ImageRotatorMixin = {
  methods: {
    rotateImage: function (img, orientation, noScaling = false) {
      if (orientation < 2 || !img) return

      // In v-for, Vue refs are delivered as arrays. We use
      // unique tags per image, so get the only element in the
      // array if it's coming from ImageList.
      if (Array.isArray(img)) {
        if (img.length === 0) return
        img = img[0]
      }

      // now img is correct, so we can continue.
      if (img.dataset && img.dataset.rotated) return

      const contentWidth = img.width
      const contentHeight = img.height
      const width = img.naturalWidth
      const height = img.naturalHeight
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')

      const widthScaleFactor = (noScaling ? 1 : contentWidth / width)
      const heightScaleFactor = (noScaling ? 1 : contentHeight / height)

      if (orientation > 4 && orientation < 9) {
        canvas.width = height * heightScaleFactor
        canvas.height = width * widthScaleFactor
      } else {
        canvas.width = width * heightScaleFactor
        canvas.height = height * widthScaleFactor
      }

      switch (orientation) {
        case 2:
        // horizontal flip
          ctx.translate(width * widthScaleFactor, 0)
          ctx.scale(-1 * widthScaleFactor, 1 * heightScaleFactor)
          break
        case 3:
          // 180° rotate left
          ctx.translate(width * widthScaleFactor, height * heightScaleFactor)
          ctx.rotate(Math.PI)
          ctx.scale(widthScaleFactor, heightScaleFactor)
          break
        case 4:
          // vertical flip
          ctx.translate(0, height * heightScaleFactor)
          ctx.scale(1 * widthScaleFactor, -1 * heightScaleFactor)
          break
        case 5:
          // vertical flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.scale(1 * widthScaleFactor, -1 * heightScaleFactor)
          break
        case 6:
          // 90° rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.translate(0, -height * heightScaleFactor)
          ctx.scale(widthScaleFactor, heightScaleFactor)
          break
        case 7:
          // horizontal flip + 90 rotate right
          ctx.rotate(0.5 * Math.PI)
          ctx.translate(width * widthScaleFactor, -height * heightScaleFactor)
          ctx.scale(-1 * widthScaleFactor, 1 * heightScaleFactor)
          break
        case 8:
          // 90° rotate left
          ctx.rotate(-0.5 * Math.PI)
          ctx.translate(-width * widthScaleFactor, 0)
          ctx.scale(widthScaleFactor, heightScaleFactor)
          break
        default: break
      }

      ctx.drawImage(img, 0, 0)
      img.src = canvas.toDataURL()
      img.dataset.rotated = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/mixins.js